<div class="flex flex-col h-full">
  <!--
    mobile class:
    !hidden sm:!flex items-center
  -->
  <mat-toolbar color="primary" class="flex items-center" desktop>
    <!-- show on search page or in tablet or desktop view -->
    <mat-toolbar-row class="justify-between gap-4">
      <img ngSrc="assets/images/logo_transparent_rectangle.png" alt="corpers.ng logo" class="w-28 cursor-pointer hidden sm:block" width="410" height="65" priority routerLink="/">
      <!-- <a class="cursor-pointer hidden sm:block" routerLink="/">corpers.ng</a> -->

      <!-- <span class="flex-1"></span> -->
      <!-- <input matInput> -->

      <!-- 
      
      [&>div:first-child]:h-[50px] [&>div:nth-child(2)]:hidden mat-mdc-form-field-subscript-wrapper 
      
      
      [&>*]:h-[45px] [&_.mat-mdc-text-field-wrapper]:h-[45px] [&_.mat-mdc-input-element]:text-[45px] [&_.mat-mdc-form-field-subscript-wrapper]:hidden
      -->
      <mat-form-field
        *ngIf="!isSearchPage"
        appearance="fill"
        color="primary"
        subscriptSizing="dynamic"
        class="flex-1 grow max-w-96 md:px-7 [&_.mat-mdc-text-field-wrapper]:rounded compact-input-theme"
      >
        <mat-label>Search PPAs, Houses, Items etc.</mat-label>
        <input
          matInput
          type="text"
          [formControl]="searchInput"
          (click)="openSearchModal()"
        />
        <button
          *ngIf="searchInput.value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="searchInput.setValue('')"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <!-- <span class="toolbar-spacer"></span> -->
      <!-- <span class="flex-1"></span> -->

      <div class="flex items-center gap-3">
        <a
          class="!hidden sm:!block"
          mat-button
          routerLinkActive="!text-accent underline"
          [routerLinkActiveOptions]="{exact: false}"
          routerLink="/messages"
        >
          <span
            matBadgePosition="after"
            matBadgeOverlap="false"
            [matBadgeHidden]="unreadMessage === 0"
            matBadgeColor="accent"
            [matBadge]="unreadMessage"
            >Chats</span
          >
        </a>
        <a 
          class="!hidden sm:!block" 
          mat-button 
          routerLinkActive="!text-accent underline"
          [routerLinkActiveOptions]="{exact: false}"
          routerLink="/ppa"
        >
          PPAs
        </a>
        <a 
          class="!hidden sm:!block" 
          mat-button 
          routerLinkActive="!text-accent underline"
          [routerLinkActiveOptions]="{exact: false}"
          routerLink="/sales"
        >
          Buy/Sell
        </a>
        <a 
          class="!hidden sm:!block" 
          mat-button 
          routerLinkActive="!text-accent underline"
          [routerLinkActiveOptions]="{exact: false}"
          routerLink="/houses"
        >
          Houses
        </a>

        <!-- <ng-container *ngIf="this.callerService.isLoggedIn">
        <button
        type="button"
        class="hide-mobile"
        mat-button
        (click)="callerService.openAddNewPPADialog()"
      >
        Add PPA
      </button>

      <button
        type="button"
        class="hide-mobile"
        mat-button
        (click)="callerService.openCreateAccommodationPostDialog()"
      >
        Post Accommodation
      </button>

      <button
        type="button"
        class="hide-mobile"
        mat-button
        (click)="callerService.openCreateSalePostDialog()"
      >
        Post Sale
      </button>
      </ng-container> -->

        <button
          type="button"
          mat-icon-button
          (menuOpened)="toggleMenuState()"
          (menuClosed)="toggleMenuState()"
          [matMenuTriggerFor]="menu"
        >
          <mat-icon class="nav-icon" aria-label="menu icon"
            >menu{{ menuState }}</mat-icon
          >
        </button>

        <mat-menu #menu="matMenu">
          <!-- <button type="button" mat-menu-item [routerLink]="['/home']">
        <mat-icon fontSet="material-icons-outlined">home</mat-icon> Home
      </button> -->
          <button
            *ngIf="callerService.isLoggedIn"
            type="button"
            mat-menu-item
            routerLinkActive="!bg-slate-100"
            [routerLink]="['/dashboard']"
            class="!hidden sm:!flex"
          >
            <mat-icon mat-menu-item-icon fontSet="material-icons-outlined"
              >dashboard</mat-icon
            >
            Dashboard
          </button>
          <!-- <button
        *ngIf="callerService.isLoggedIn"
        type="button"
        mat-menu-item
        [routerLink]="['/messages']"
      >
        <mat-icon
          matBadgePosition="after"
          matBadgeOverlap="true"
          [matBadgeHidden]="unreadMessage === 0"
          matBadgeColor="accent"
          [matBadge]="unreadMessage"
          fontSet="material-icons-outlined"
          >chat</mat-icon
        >
        <p>Messages</p>
      </button> -->
          <!-- TODO: should (people, places, things) as a sub tiny texts? -->
          <button
            type="button"
            mat-menu-item
            routerLinkActive="!bg-slate-100"
            (click)="openSearchModal()"
          >
            <mat-icon>search</mat-icon> Search
          </button>
          <button
            *ngIf="callerService.isLoggedIn"
            type="button"
            mat-menu-item
            routerLinkActive="!bg-slate-100"
            [routerLink]="['/profile']"
          >
            <mat-icon>account_circle</mat-icon>
            Profile
          </button>
          <button
            *ngIf="callerService.isLoggedIn && wishlistEnabled"
            type="button"
            mat-menu-item
            (click)="openWishlist()"
          >
            <mat-icon>favorite_border</mat-icon>
            My wishlist
          </button>
          <mat-divider></mat-divider>
          <button
            *ngIf="callerService.isLoggedIn"
            type="button"
            mat-menu-item
            (click)="logout()"
          >
            <mat-icon>logout</mat-icon> Logout
          </button>
        </mat-menu>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>

  <app-email-verification-banner></app-email-verification-banner>
  <app-onboarding-checklist></app-onboarding-checklist>

  <div class="flex-1 overflow-auto">
    <router-outlet></router-outlet>
  </div>

  <!-- Hide with css -->
  <mat-toolbar color="primary" class="sm:!hidden" mobile>
    <mat-toolbar-row class="justify-evenly !p-0">
      <button
        *ngIf="callerService.isLoggedIn"
        type="button"
        mat-menu-button
        routerLinkActive="text-accent underline"
        [routerLinkActiveOptions]="{exact: false}"
        [routerLink]="['/messages']"
      >
        <mat-icon
          matBadgePosition="after"
          matBadgeOverlap="true"
          [matBadgeHidden]="unreadMessage === 0"
          matBadgeColor="accent"
          [matBadge]="unreadMessage"
          >chat</mat-icon
        >
        <p class="mb-0 text-xs -mt-2.5">Chats</p>
      </button>

      <!-- <button type="button" mat-icon-button (click)="callerService.openAddNewPPADialog()">
        <mat-icon aria-label="create new accommodation icon">add_home_work</mat-icon>
      </button> -->

      <button
        type="button"
        mat-menu-button
        routerLinkActive="text-accent underline"
        [routerLinkActiveOptions]="{exact: false}"
        [routerLink]="['/ppa']"
      >
        <mat-icon class="!fill-slate-950" aria-label="Find & Review PPAs"
          >domain</mat-icon
        >
        <p class="mb-0 text-xs -mt-2.5">PPAs</p>
      </button>

      <button
        type="button"
        mat-menu-button
        routerLinkActive="text-accent underline"
        [routerLinkActiveOptions]="{exact: false}"
        [routerLink]="['/sales']"
      >
        <mat-icon class="!fill-slate-950" aria-label="Buy/Sell">sell</mat-icon>
        <p class="mb-0 text-xs -mt-2.5">Buy/Sell</p>
      </button>

      <!-- @todo: ??? -->
      <!-- <button
        type="button"
        mat-menu-button
        routerLinkActive="text-white"
        [routerLink]="['/search']"
      >
        <mat-icon
          class="!fill-slate-950"
          aria-label="create new accommodation icon"
          >search</mat-icon
        >
        <p class="mb-0 text-xs -mt-2.5">Search</p>
      </button> -->

      <!-- <button type="button" mat-menu-button (click)="callerService.openAddNewPPADialog()">
        <mat-icon aria-label="create new sale icon">new_label</mat-icon>
        <p class="mb-0 text-xs -mt-2.5">Add PPA</p>
      </button> -->

      <button
        type="button"
        mat-menu-button
        routerLinkActive="text-accent underline"
        [routerLinkActiveOptions]="{exact: false}"
        [routerLink]="['/houses']"
      >
        <mat-icon aria-label="houses icon">house</mat-icon>
        <p class="mb-0 text-xs -mt-2.5">Houses</p>
      </button>

      <button
        type="button"
        mat-menu-button
        routerLinkActive="text-accent underline"
        [routerLinkActiveOptions]="{exact: false}"
        [routerLink]="['/dashboard']"
      >
        <mat-icon aria-label="dashboard icon">dashboard</mat-icon>
        <p class="mb-0 text-xs -mt-2.5">Dashboard</p>
      </button>

      <a
        mat-menu-button
        href="https://blog.corpers.ng"
        target="_blank"
        rel="noopener noreferrer"
        class="flex flex-col items-center justify-center text-white no-underline cursor-pointer"
      >
        <mat-icon>menu_book</mat-icon>
        <p class="mb-0 text-xs">Resources</p>
      </a>
    </mat-toolbar-row>
  </mat-toolbar>
</div>
